import {
  img1, img2, img3, img4, img5, img6, img7, img8, img11, img12
} from '../assets/images';

export const leadership = [
  {
    name: "Mrs. Anita Das",
    role: "Principal",
    exp: "15+ Years Experience",
    qual: "M.Ed., B.Ed., ECE Certified",
    bio: "Mrs. Das founded Happykidz Preschool with a vision to provide quality early education in Bhubaneswar. Her passion for children's holistic development drives the school's mission.",
    image: img11,
    fav: "The Very Hungry Caterpillar",
  },
  {
    name: "Mrs. Priya Mohapatra",
    role: "Vice Principal",
    exp: "12+ Years Experience",
    qual: "B.Ed., Montessori Certified",
    bio: "Mrs. Mohapatra oversees curriculum development and teacher training, ensuring every classroom delivers the highest quality of Montessori-inspired play and early learning.",
    image: img12,
    fav: "Where the Wild Things Are",
  },
];

export const teachers = [
  {
    name: "Ms. Kavita Sharma",
    role: "Nursery Class Teacher",
    exp: "8 Years",
    qual: "B.Ed., Child Psychology",
    image: img1,
    fav: "Goodnight Moon"
  },
  {
    name: "Ms. Ritu Panda",
    role: "Kindergarten Teacher",
    exp: "6 Years",
    qual: "M.A. Education",
    image: img2,
    fav: "Charlotte's Web"
  },
  {
    name: "Mr. Suresh Nayak",
    role: "Physical Education Teacher",
    exp: "10 Years",
    qual: "B.P.Ed., Sports Science",
    image: img3,
    fav: "The Champion Sports Kid"
  },
  {
    name: "Ms. Deepa Rath",
    role: "Art & Craft Teacher",
    exp: "7 Years",
    qual: "BFA, Art Education",
    image: img4,
    fav: "Harold and the Purple Crayon"
  },
  {
    name: "Ms. Sunita Mishra",
    role: "Music & Movement Teacher",
    exp: "5 Years",
    qual: "B.Mus., Classical Music",
    image: img5,
    fav: "Peter and the Wolf"
  },
  {
    name: "Ms. Pooja Singh",
    role: "Playgroup Teacher",
    exp: "4 Years",
    qual: "B.Ed., Early Childhood Ed.",
    image: img6,
    fav: "Pat the Bunny"
  },
  {
    name: "Mr. Amit Kumar",
    role: "Computer Teacher",
    exp: "6 Years",
    qual: "MCA, CTET Qualified",
    image: img7,
    fav: "Ada Twist, Scientist"
  },
  {
    name: "Ms. Meena Behera",
    role: "Library & Storytelling Coordinator",
    exp: "9 Years",
    qual: "M.Lib., Storytelling Expert",
    image: img8,
    fav: "The Giving Tree"
  },
];
